import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Sidebar from './sidebar/Sidebar';
import RightPanelContent from './rightPanelContent/RightPanelContent';
import LeftPanelContent from './leftPanelContent/LeftPanelContent';
import MainContent from './mainContent/MainContent';
import Modal from './modal/Modal';
import { Slide, ToastContainer } from 'react-toastify';
import { translate } from "react-i18next";
import { signOut } from './../../actions/auth';
import { version, mainAddress } from './../../config';
import 'react-toastify/dist/ReactToastify.css';
import messageManager from './../../utilities/messageManager';
import { getFlights } from './../../actions/flightManager';
import loading from './../../utilities/loading';
import { setProject } from './../../actions/auth';
import {
    turnOnLiveStreamStartedNotification,
    turnOnLiveStreamFinishedNotification,
    turnOffLiveStreamStartedNotification,
    turnOffLiveStreamFinishedNotification,
    turnOnDronePositionUpdateNotification,
    turnOffDronePositionUpdateNotification
} from './../../utilities/webSocketNotifications';
import { setStreamTransmiting } from './../../actions/video';
import { fieldsDictionary } from './../../utilities/flightDictionaries';

const StyledWrapper = styled.div`
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

class Content extends React.Component {
    resizeObservable = {
        callbacks: [],
        subscribe: function (callback: (any) => {}) {
            this.callbacks.push(callback);
        },
        fireCallbacks: function () {
            this.callbacks.forEach(callback => {
                callback();
            })
        }
    };

    confirmCookiePolicy(t) {
        const config = {
            title: t('Cookie policy'),
            content: <p>{t('Do you accept our cookie policy')} </p>,
            confirmCallback: () => {
                localStorage.setItem('cookie_confirmation', 'true');
            },
            cancelBtnVisible: false,
            confirmBtnVisible: true,
            confirmBtnText: t('Continue'),
            closeOnConfirm: true,
            type: 'info',
        }
        cookieModalInstance.customize(config);
        cookieModalInstance.show();
    }

    confirmRodoPolicy(t, signOut) {
        const config = {
            title: 'RODO',
            content: <p>{t('Do you accept our data management policy').replace("{address}", mainAddress)} </p>,
            confirmCallback: () => {
                localStorage.setItem('rodo_confirmation', 'true');
            },
            cancelCallback: () => {
                signOut();
                localStorage.setItem('rodo_confirmation', 'false');
            },
            cancelBtnVisible: true,
            confirmBtnVisible: true,
            confirmBtnText: t('Accept'),
            closeOnConfirm: true,
            type: 'info',
        }
        modalInstance.customize(config);
        modalInstance.show();
    }

    confirmDemoData() {
        const { BASE_URL, chosenProject, axiosInstance, t, setProject } = this.props;
        loading.start();

        const confirmCallback = () => {
            setTimeout(() => {
                const config = {
                    title: t('Demo data'),
                    content: <p>{t('Please wait Creating demo data')}</p>,
                    confirmBtnVisible: false,
                    cancelBtnVisible: false,
                    type: 'info',
                }
                modalInstance.customize(config);
                modalInstance.show();
            }, 0);

            axiosInstance.post(`${BASE_URL}projects/demo`)
                .then(() => {
                    messageManager.show({
                        text: t('First project with demo data created'),
                        type: 'info',
                    });
                    this.props.getFlights(this.props.axiosInstance);
                    chosenProject.projectsCount = 1;
                    setProject(chosenProject);

                    loading.stop();
                    modalInstance.close();
                })
                .catch((error) => {
                    messageManager.show({
                        type: 'error',
                        text: error.response && error.response.data ? error.response.data : t('Error occured while creating project with demo data'),
                    });
                    loading.stop();
                    modalInstance.close();
                });
        }

        const config = {
            title: t('Demo data') + '?',
            content: <p>{t('Workspace is empty Would you like to create first project with demo data')}</p>,
            confirmCallback: confirmCallback,
            cancelCallback: () => { },
            confirmBtnVisible: true,
            cancelBtnVisible: true,
            confirmBtnText: t('Yes'),
            cancelBtnText: t('No'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
        modalInstance.show();
    }

    initLiveStreamNotification() {
        const { BASE_URL, axiosInstance, setStreamTransmiting } = this.props;
        axiosInstance.get(`${BASE_URL}live-channel`)
            .then(response => {
                const { data } = response;
                // TODO: obsluga wielu streamow
                if (data.length > 0) setStreamTransmiting(true, data[0].hlsUrl);
                else setStreamTransmiting(false);
            });

        turnOnLiveStreamStartedNotification((projectId, url) => {
            const { t, flights, setStreamTransmiting } = this.props;
            const flight = flights.find(flight => flight.id === projectId);
            if (flight) {
                messageManager.show({
                    type: 'info',
                    text: `${t('Livestream started.')} ${t('Select flight')} ${flight.projectName} ${t('go to video tab and click LIVE button')}`,
                })
            }
            setStreamTransmiting(true, url);
        });

        turnOnLiveStreamFinishedNotification((projectId) => {
            const { t, flights, setStreamTransmiting } = this.props;
            const flight = flights.find(flight => flight.id === projectId);
            if (flight) {
                messageManager.show({
                    type: 'info',
                    text: t('Livestream finished'),
                })
            }
            setStreamTransmiting(false, null);
        });

        turnOnDronePositionUpdateNotification((point) => {
            //TODO: obsluga pozycji live
            console.log(point);
        });
    }

    //set visability in fieldsDictionary object, this is for mission attributes
    initFlightAttributes() {
        const { BASE_URL, axiosInstance, t, chosenProject } = this.props;
        loading.start();
        axiosInstance.get(`${BASE_URL}customers/${chosenProject.customerId}/visible-attributes`)
            .then((response) => {
                Object.keys(fieldsDictionary).forEach(field => {
                    fieldsDictionary[field].visible = false;
                });
                response.data.forEach(attribute => {
                    fieldsDictionary[attribute.name].visible = true;
                });
                loading.stop();
            })
            .catch((error) => {
                messageManager.show({
                    type: 'error',
                    text: t(error),
                })
                loading.stop();
            })
    }

    componentDidMount() {
        const rodoConfirmation = localStorage.getItem('rodo_confirmation');
        const cookieConfirmation = localStorage.getItem('cookie_confirmation');
        const { signOut, t, chosenProject } = this.props;

        if (cookieConfirmation !== 'true') {
            this.confirmCookiePolicy(t);
        }
        if (rodoConfirmation !== 'true') {
            this.confirmRodoPolicy(t, signOut);
        }
        if (!chosenProject.projectsCount) {
            this.confirmDemoData();
        }

        this.initLiveStreamNotification();
        this.initFlightAttributes();
    }

    componentWillUnmount() {
        turnOffLiveStreamStartedNotification();
        turnOffLiveStreamFinishedNotification();
        turnOffDronePositionUpdateNotification();
    }

    render() {
        const { selected, t } = this.props;
        const titleDictionary = {
            default: 'Legend',
            video: 'Videos',
            gallery: 'Gallery',
            model: 'Models',
            resource: 'Attachments',
        }
        const rightSidebarTitle = String(t(titleDictionary[selected])).toUpperCase();
        let leftSidebarTitle = this.props.appName;
        leftSidebarTitle = this.props.versionVisible ? (leftSidebarTitle + ` v. ${version}`) : leftSidebarTitle;

        return (
            <StyledWrapper
                onClick={(e) => {
                    this.setState({ menuVisible: false })
                    e.stopPropagation();
                }}>
                <Sidebar
                    resizeObservable={this.resizeObservable}
                    defaultWidth='25%'
                    location='left'
                    title={leftSidebarTitle}>
                    <LeftPanelContent />
                </Sidebar>
                <MainContent resizeObservable={this.resizeObservable} />
                <Sidebar
                    defaultWidth='16%'
                    resizeObservable={this.resizeObservable}
                    location='right'
                    title={rightSidebarTitle}>
                    <RightPanelContent />
                </Sidebar>
                <Modal ref={(cookieNode) => {
                    if (cookieNode !== null) {
                        cookieModalInstance = cookieNode.getWrappedInstance()
                    }
                }} />
                <Modal ref={(translatedNode) => {
                    if (translatedNode !== null) {
                        modalInstance = translatedNode.getWrappedInstance()
                    }
                }} />
                <ToastContainer
                    draggablePercent={60}
                    transition={Slide}
                />
            </StyledWrapper>
        );
    }
};


const mapStateToProps: MapStateToProps<*, *, *> = state => ({
    selected: state.modules.get('selected'),
    chosenProject: state.auth.get('chosenProject'),
    axiosInstance: state.auth.get('axiosInstance'),
    flights: state.flightManager.get('rawData'),
    appName: state.domainProperties.get('appName'),
    versionVisible: state.domainProperties.get('versionVisible'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    signOut,
    setProject,
    getFlights,
    setStreamTransmiting,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(Content));

export let modalInstance: ModalInstance;
let cookieModalInstance: ModalInstance;


// WEBPACK FOOTER //
// ./src/containers/content/Content.jsx